// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap';
const initBootstrap = bootstrap;
// Import global ts files
import { Navigation } from './navigation';
import { Reviews } from './reviews';
import { Carousel } from './carousel';
import { Utils } from './utils';
import { Accordion } from './accordions';
import { News } from './news';
import { NewsletterSignup } from './newsletterSignup';
const navigation = new Navigation();
const reviews = new Reviews();
const carousel = new Carousel();
const accordion = new Accordion();
const news = new News();
const newsletterSignup = new NewsletterSignup();
/**
 * Initialises page contents with Intersection Observers which when 20% of the element enters the
 * viewport updates the elements class with the "scroll-visible" class.
 */
function fadeInContent() {
    // Target the pages content ignoring the Hero, Nav and Footer elements
    const pageContent = document.querySelector("#page-content");
    // Initialise IntersectionObserverCallback functionality
    const callback = Utils.FadeIntoViewportCallback();
    if (pageContent != null) {
        // Retrieve the layouts from the page content
        const layouts = pageContent.querySelectorAll(".umb-block-grid__layout-item");
        for (let i = 0; i < layouts.length; i++) {
            // Retrieve the areas from each of the layouts surrounding the content of the page
            let areaContent = layouts[i].querySelectorAll(".umb-block-grid__layout-item");
            for (let j = 0; j < areaContent.length; j++) {
                // Retrieve the contents of the areas for attaching IntersectionObservers
                let content = Array.from(areaContent[j].children);
                // Foreach Element attach required IntersectionObservers passing the created callback function.
                content.forEach(element => {
                    Utils.RespondToVisibility(element, null, undefined, 0.2, callback);
                });
            }
        }
    }
}
;
window.onload = function () {
    navigation.NavigationOnLoad();
    accordion.InitialiseAccordions();
    carousel.InitialiseCarousels();
    reviews.InitialiseReviewCarousels();
    news.InitialiseReviewListings();
    newsletterSignup.InitializeFormValidation();
    fadeInContent();
};
window.onresize = function () {
    navigation.NavigationOnResize();
    carousel.UpdateCarousels();
};
window.onscroll = function () {
    navigation.NavigationOnScroll();
};
